export const SMALL_MODAL = 'e-modal'
export const FULL_MODAL = 'e-form-modal'

export const GARBAGE_HEAP = 'heap'
export const GARBAGE_ORO = 'oro'

export const PERIODS = [
  {id: 0, name: 'Весь'},
  {id: 3, name: '3 года'},
  {id: 5, name: '5 лет'},
  {id: 10, name: '10 лет'},
  {id: 15, name: '15 лет'}
]

export const REPORT_NAME = {
  TP2: 5,
  INDICATOR: 9,
  RSO: 13,
  BATTERY: 14,
  UNAUTH: 6,
  MSN: 12,
  MSN_INDICATOR: 2,
  RECYCLE: 16,
  OBJECTS_PROCESSING: 3,
  OBJECTS_PLACING: 31,
  TECH: 4,
  GARBAGE_BANK: 8,
  MMCO: 1,
  GARBAGE_VOLUME_BY_MO: 17,
  TP2Revegetation: 18,
  // billing
  ACT_RECONCILIATION: 1001,
  COLLECTION: 1002
}

export const cardClassFull = ''
export const cardClassOnlyApo = 'report-card--type2'
export const cardClassWithOutApo = 'report-card--type3'
export const cardClassEmpty = 'report-card--type4'
